import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { CheckOutlined, CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import Drawer from 'components/AntEnhancement/Drawer';
import ClinicRoomForm from 'components/forms/settings/ClinicRoomForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import services from 'services';
import './ClinicRoomDrawer.css';
var ClinicRoomDrawer = function (props) {
    var _a, _b;
    var visiable = props.visiable, onCloseDrawer = props.onCloseDrawer, clinicRoom = props.clinicRoom, clinics = props.clinics, receptionDesks = props.receptionDesks, specializations = props.specializations, translate = props.translate, isEdit = props.isEdit;
    var _c = useState(false), disabled = _c[0], setDisabled = _c[1];
    var form = Form.useForm()[0];
    var onClose = function () { return onCloseDrawer(); };
    var clinicRoomService = services.clinicRoomService;
    var _d = clinicRoomService.useCreateClinicRoom(), createRoom = _d.mutate, isCreated = _d.isSuccess, createError = _d.isError;
    var _e = clinicRoomService.useUpdateClinicRoom(), updateRoom = _e.mutate, isUpdated = _e.isSuccess, updateError = _e.isError;
    useEffect(function () {
        if (isCreated || isUpdated) {
            onClose();
        }
    }, [isCreated, isUpdated]);
    useEffect(function () {
        if (createError || updateError) {
            setDisabled(false);
        }
    }, [createError, updateError]);
    var onSubmit = function () {
        if (!clinicRoom || disabled)
            return;
        setDisabled(true);
        if (!isEdit) {
            createRoom({
                clinicRoom: clinicRoom,
                successMessage: translate('clinicRooms.messages.created')
            });
        }
        else {
            updateRoom({
                clinicRoom: clinicRoom,
                successMessage: translate('clinicRooms.messages.updated')
            });
        }
    };
    var formKey = "clinic-room-form-".concat((_a = clinicRoom === null || clinicRoom === void 0 ? void 0 : clinicRoom.getId()) !== null && _a !== void 0 ? _a : 0, "-").concat(Number(visiable));
    return (_jsx(Drawer, { title: null, placement: "right", open: visiable, onClose: onClose, closable: false, destroyOnClose: true, width: 440, rootClassName: "clinic-room-drawer", className: "clinic-room-drawer", children: _jsxs(Form, { form: form, layout: "vertical", className: "clinic-room-drawer__shell", requiredMark: false, onFinish: onSubmit, onValuesChange: function (changed) {
                var _a, _b;
                if (!clinicRoom)
                    return;
                if (Object.prototype.hasOwnProperty.call(changed, 'name')) {
                    clinicRoom.setName((_a = changed.name) !== null && _a !== void 0 ? _a : '');
                }
                if (Object.prototype.hasOwnProperty.call(changed, 'code')) {
                    clinicRoom.setCode((_b = changed.code) !== null && _b !== void 0 ? _b : '');
                }
                if (Object.prototype.hasOwnProperty.call(changed, 'reception_desk')) {
                    clinicRoom.setReceptionDeskId(Number(changed.reception_desk));
                }
                if (Object.prototype.hasOwnProperty.call(changed, 'specialization')) {
                    clinicRoom.setSpecializationId(Number(changed.specialization));
                }
                if (Object.prototype.hasOwnProperty.call(changed, 'active')) {
                    clinicRoom.setActive(Boolean(changed.active));
                }
            }, initialValues: {
                name: (clinicRoom === null || clinicRoom === void 0 ? void 0 : clinicRoom.getName()) || '',
                code: (clinicRoom === null || clinicRoom === void 0 ? void 0 : clinicRoom.getCode()) || '',
                reception_desk: (clinicRoom === null || clinicRoom === void 0 ? void 0 : clinicRoom.getReceptionDeskId()) || undefined,
                specialization: (clinicRoom === null || clinicRoom === void 0 ? void 0 : clinicRoom.getSpecializationId()) || undefined,
                active: (_b = clinicRoom === null || clinicRoom === void 0 ? void 0 : clinicRoom.isActive()) !== null && _b !== void 0 ? _b : true
            }, children: [_jsxs("header", { className: "clinic-room-drawer__header", children: [_jsxs("div", { className: "clinic-room-drawer__title-block", children: [_jsx("span", { className: "clinic-room-drawer__dot", "aria-hidden": true }), _jsxs("div", { children: [_jsx("h2", { className: "clinic-room-drawer__title", children: isEdit
                                                ? translate('clinicRooms.drawers.editTitle')
                                                : translate('clinicRooms.drawers.addTitle') }), _jsx("p", { className: "clinic-room-drawer__subtitle", children: isEdit
                                                ? translate('clinicRooms.drawers.editSubtitle')
                                                : translate('clinicRooms.drawers.addSubtitle') })] })] }), _jsx("button", { type: "button", className: "clinic-room-drawer__close", onClick: onClose, "aria-label": translate('common:buttons.close'), children: _jsx(CloseOutlined, {}) })] }), _jsxs("div", { className: "clinic-room-drawer__body", children: [clinicRoom ? (_jsx(ClinicRoomForm, { clinicRoom: clinicRoom, clinics: clinics, receptionDesks: receptionDesks, specializations: specializations })) : null, _jsxs("p", { className: "clinic-room-drawer__note", children: [_jsx(InfoCircleOutlined, {}), _jsx("span", { children: translate('clinicRooms.drawers.info') })] })] }), _jsxs("footer", { className: "clinic-room-drawer__footer", children: [_jsx("button", { type: "button", className: "clinic-room-drawer__btn clinic-room-drawer__btn--ghost", onClick: onClose, children: translate('common:buttons.cancel') }), _jsxs("button", { type: "submit", className: "clinic-room-drawer__btn clinic-room-drawer__btn--primary", disabled: disabled || !clinicRoom, children: [_jsx(CheckOutlined, {}), _jsx("span", { children: disabled
                                        ? translate('clinicRooms.drawers.saving')
                                        : translate('clinicRooms.drawers.save') })] })] })] }, formKey) }));
};
export default localeTranslator(ClinicRoomDrawer, 'settings');
